import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
import "../../css/course-page.css";


class Statisticsforresearcherscourse extends Component {
    render() {
        return (
            <div>
                   <div aria-label="breadcrumb">
                       <ol class="breadcrumb">
                           <li class="breadcrumb-item"><Link ><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                            <li class="breadcrumb-item active">Statistics for Researchers Course</li>
                        </ol>
                    </div>
                    <section class="course-header bg-blue11" id="course-header" >
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5 six-sigma-bkg"                 
                            >
                                    <h1>Statistics for <br />Researchers Course</h1>
                                    <br />
                                    <br />
                                    <br />
                                    <div class="form-group">
                                        
                                        <a href="#apply-nows" class="btn btn-md enroll-btn" >Enroll Now </a>
                                       
                                        <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                                        data-target="#myModal" >Download
                                        brochure</button><br /> <br /><br /><br />
                                       
                                    </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-1"></div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                    <br />
                                        <p>Certification jointly awarded by</p>
                                            <ul>
                                                <li><img alt="executive" width="" src="/assets/images/isi.svg" />  </li>
                                                <li><img width="" src="/assets/images/epn.svg" alt="executive" /></li>
                                            </ul>
                                            <br />
                                    </div>
                            </div>
                            
                            </section>

                            <div class="course-main-contains def-z"  id="Description">
                                <div class="card">
                                    <div class="row contanint-display">
                                        <div class="col-lg-6 col-xl-6 col-12 col-sm-12 col-md-6">    
                                        <b>Schedule:</b><br />
                                     
                                        </div>
                                        <div class="col-lg-6 col-xl-6 col-12 col-sm-12 col-md-6" >    
                                            <b> <i class="fa fa-calendar" ></i>&nbsp; Upto 3 Days</b><br />
                                            <b>(Customisable as per requirements)</b>
                                        </div>
                                        
                                    </div>
                                </div>
                                </div>

                                <section class="def-z">
                                    <div class="header" id="myHeader">
                                            <ul>
                                                <li><a href="#Description">Description</a></li>
                                                <li><a href="#Eligibility">Eligibility</a></li>
                                                <li><a href="#syllabus">Syllabus</a></li>               
                                                <li><a href="#Schedule">Schedule</a></li>           
                                                <li><a href="#Review-s">Learner Review</a></li>          
                                                <li><a href="#Certification-s">Certification</a></li>          
                                                <li class="btn-header cs-dx"><a href="#apply-nows">Enroll Now</a></li>            
                                            </ul>
                                    </div>
                                </section>

                                <section class="course-description six-sigma-des" id="course-description">
                                    <br />
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <br />
                                            <h3 id="Eligibility">Program Overview</h3>
                                            <p align="justify">Research is an unavoidable aspect of engagement for academia. Statistics is often used to reinforce a research point or subject. Statistics allows a domain research to proceed to the intended conclusion with factual arguments. However, not all researchers are able to understand the role of statistics and adapt it in their research. </p>
                                            <p align="justify"> In this program, the Indian Statistical Institute, Pune chapter outlines the topics that help researchers get clarity on the role of statistics in research.
                                            </p>
                                        </div>
                                       
                                    </div><br />
                                    <div class="row owl-carousel-end">
                                            <div class="col-sm-12">
                                                <h3 id="syllabus">Who Should Enroll?</h3>
                                                <ul class="highlight-ul">
                                                    <li>Researchers</li>
                                                    <li>Faculty Members</li>
                                                </ul>
                                            </div>
                                        </div>
                                  
                                    </section>
                                    <section class="course-syllabus" id="course-syllabus">
            <div class="row" >
                  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10">
                     <h3>Program Curriculum</h3>
                     <br />
                     <div class="syl-bg">
                     <div id="de_syllabus">
                        <div class="panel-group">
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                                 href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> Introduction
                                 </h6>
                              </div>
                              <div id="de_syllabus1" class="collapse show" aria-labelledby="de_heading1"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul" >
                                       
                                    </ul>
                                 </div>
                              </div>
                           </div>
     
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading2" data-toggle="collapse"
                                 href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i>Research methodology and statistics - the interface elements
                                 </h6>
                              </div>
                              <div id="de_syllabus2" class="collapse show" aria-labelledby="de_heading2"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul" >
            
                                    </ul>
                                 </div>
                              </div>
                           </div>

                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading3" data-toggle="collapse"
                                 href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                 <h6 class="panel-title">
                                   <i class="indicator fa fa-minus"></i>Basic Statistics
                                 </h6>
                              </div>
                              <div id="de_syllabus3" class="collapse show" aria-labelledby="de_heading3"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                            <li>Data Preparation</li>
                                            <li>Problem Formulations</li>
                                            <li>Probability, Random Variable, Probability Distributions, Estimation, summaries of statistics and
                                                data visualisations</li>
                                            <li>Sampling distributions and Test of Hypothesis</li>
                                    </ul>
                                 </div>
                              </div>
                           </div>

                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading4" data-toggle="collapse"
                                 href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                 <h6 class="panel-title">
                                   <i class="indicator fa fa-minus"></i>Multivariate statistics - Principal Factor Analysis and Factor Analysis, Clustering
                                 </h6>
                              </div>
                              <div id="de_syllabus4" class="collapse show" aria-labelledby="de_heading4"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul" >
                                        
                                  </ul>
                                 </div>
                              </div>
                           </div>
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading114" data-toggle="collapse"
                                 href="#de_syllabus114" aria-expanded="true" aria-controls="de_syllabus114">
                                 <h6 class="panel-title">
                                   <i class="indicator fa fa-minus"></i>Modelling
                                 </h6>
                              </div>
                              <div id="de_syllabus114" class="collapse show" aria-labelledby="de_heading114"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul" >
                                    <li> Multiple Linear Regressions</li>
                                        <li> Logistic Regression</li>
                                        <li> Decision Tree</li>
                                  </ul>
                                 </div>
                              </div>
                           </div>

                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading6" data-toggle="collapse"
                                 href="#de_syllabus6" aria-expanded="true" aria-controls="de_syllabus6">
                                 <h6 class="panel-title">
                                   <i class="indicator fa fa-minus " id="Schedule"></i>DoE &amp; ANOVA
                                 </h6>
                              </div>
                           </div>
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading7" data-toggle="collapse"
                                 href="#de_syllabus7" aria-expanded="true" aria-controls="de_syllabus7">
                                 <h6 class="panel-title">
                                   <i class="indicator fa fa-minus" ></i>Case Studies &amp; Participants’ Cases
                                 </h6>
                              </div>
                           </div>
                        </div>
                    </div>
                     </div>

                  </div>
                  </div>

            </section>
          
             <section class="course-admission-process bg-white" id="course-admission-process">
                
             </section> 
             <Aboutuslearners />     
                <Aluminicompany />
              
            <section class="course-learning-outcome bg-secondary1 " id="course-learning-outcome">
               <div class="row">
                  <div class="col-sm-6">
                     <h3>Certification</h3>
                     <br />
                     <p align="justify">ISI Pune will award participants a formal certificate of Statistics for Researchers after the participants pass a test conducted on the last day of the session with at least 70% score.</p> 
                     <br />                     
                  </div>
                  <div class="col-sm-6">
                     
                  <img src="</assets/images/icons/certificate-final.png" alt="Statistics for Researchers Course" />

                <p class="img-below-text text-center" id="apply-nows">Awarded Jointly by The Indian Statistical Institute,<br />Pune and
                    edu plus now </p>
                  </div>
               </div>
               <br /><br />
            </section>
            
            <section class="courses-feesm">
            <section class="course-fees" id="course-fees">
            <div class="row box-sh" >
                   <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                    
                   
                    </div>
                    <div class="vertical-line-fee"> </div>
                    <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                        <div class="row">
                            <div class="col-sm-10"> <br /><br />
                                <h5>Features</h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-sm-12">
                              <ul class="highlight-ss" >
                                 <li>	Excel functions </li>
                                 <li>	Reports</li>
                                 <li>	Lookups  </li>
                                 <li>	Pivot tables  </li>
                              </ul>
                            </div>
                            <p>{// eslint-disable-next-line
                               }<marquee onmouseover="this.stop();" onmouseout="this.start();" class="marquee-enroll" >"If a group of four or more participants enroll with us, a concession of 10% will be awarded to each one of them. For more details Contact us."<a href="tel://8956167195 " > &nbsp;&nbsp;<i class="fa fa-mobile" aria-hidden="true"></i> +91 8956167195</a></marquee>
                           </p>  
                        </div> 
                     </div>
                </div>
             </section> 
             </section> 
             <Whyedu/>

            <section class="course-about-instructor bg-secondary"  id="course-about-instructor">
                 <div class="row">
                     <div class="col-sm-12">
                         <h3>About the Organization </h3>
                                 <br /> 
                                 <img width="" src="/assets/images/isi-black.svg" alt="Indian Statistical Institute" />
                                 <br /><br />
                                 <p align = "justify">It is a Central Government institute, devoted to research, teaching & application of
                                     not only statistics and allied sciences, but also the natural sciences, social
                                     sciences and their interface with the statistics. Founded by Professor P.C.
                                     Mahalanobis in Kolkata on 17th December, 1931, the institute gained the status of
                                     an Institution of National Importance by an act of the Indian Parliament in 1959.
                                 </p>

                                 <br />
                                 <p align = "justify">ISI Pune is a unit of Indian Statistical Institute, active in Teaching, Training,
                                     Research and Consulting on application of statistics, operations research & allied
                                     science to solve problems of the industry across the spread and depth of the
                                     industries. ISI Pune bring sanctity of statistics in the mother initiatives such as
                                     TQM, TPM, Six Sigma, Quality Management, Management Systems, Business Management,
                                     Data Analytic, Data Science. </p>

                     </div>
                 </div>
             </section>

            <div class="modal fade bd-example-modal-sm" id="myModal" role="dialog" >
                 <div class="modal-dialog modal-md">
                     <div class="modal-content">
                         <div class="modal-header" >
                             <span class="close" id="close_form"
                                     data-dismiss="modal">&times;</span>
                                <br />
                         </div>
                         <div class="modal-body" >
                             <div class="panel panel-default paper-shadow box_detail" >
                                 <h5 class="text-center "> Download The Course Brochure </h5>
                                 <form method="post" class="form-row"  onsubmit="return validate()">

                                     <b>Your Name</b><input class="form-control" pattern="[A-Za-z ]{1,32}" type="text"
                                         required="" autocomplete="on" name="name" id="name" />
                                     <b>Your email</b><input class="form-control" type="email" required=""
                                         autocomplete="on" name="emaill" id="emaill" />
                                     <b>Your Contact No</b><input class="form-control" pattern="[7-9]{1}[0-9]{9}"
                                         type="tel" required="" autocomplete="on" name="contactt" id="contactt" />
                                         <input type="hidden" name="id" id="exd-course-name" value='<?php echo $words[0]; ?>' />
                                     <input type="hidden" id="backurl" value="<?php echo $backurl?>" />
                                     <br />
                                     <div>
                                         <div class="form-group">
                                         <div  id="recaptcha" class="g-recaptcha"
                                             data-sitekey="6Lejh30UAAAAAPhZirvpXtobtIE80K7NUzsDqKjE"></div>
                                             <div id="captcha"></div>
                                         </div>
                                     </div>
                                     
                                    
                                     <div class="mob_cb" >

                                         <div>
                                         </div><br />
                                       
                                          <button class="btn_1 rounded" type="button" onclick="getbroucher(<?php echo '\''.$filepath.'\'';?>)"  id="exd-download" ><i class="icon-download"></i> Brochure</button></div>                                     
                                      <br />

                                    
                                    

                                 </form>
                             </div>
                         </div>
                     </div>

                 </div>

             </div>
      </div>
     
      

           
        );
    }
}

export default Statisticsforresearcherscourse;